import { render, staticRenderFns } from "./GeneralLookup.vue?vue&type=template&id=23696c4b&scoped=true&"
import script from "./GeneralLookup.vue?vue&type=script&lang=js&"
export * from "./GeneralLookup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLookup.vue?vue&type=style&index=0&id=23696c4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23696c4b",
  null
  
)

export default component.exports